import { useEffect } from "react";

export const makeAllSlidesAriaHidden = () => {
  const a11yTimeout = setTimeout(() => {
    clearTimeout(a11yTimeout);

    document.querySelectorAll('.abyss-slide-container').forEach((element) => {
      element.setAttribute('aria-hidden', 'false');
    });
  }, 500);
};

export const usePreventScrollPropagation = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) {
      return () => {};
    }

    const handler = (e: Event) => {
      e.stopImmediatePropagation();
    };

    document.addEventListener('wheel', handler, {
      capture: true,
      passive: true,
    });

    return () => {
      document.removeEventListener('wheel', handler);
    };
  }, [isOpen]);
};